import { Field } from 'factorial-form'

import { normalizeSubdomain } from 'modules/core/components/BrowserBarPreview'
import i18n from 'modules/core/lib/i18n'

export const validateSubdomain = (field: Field) => {
  const regex = /^(?!www\.|https?:\/\/)(?!.*\.(?:com|es)$)[a-z0-9-]+.*[A-Za-z0-9]$/
  const subdomain = normalizeSubdomain(field.value)

  if (regex.test(subdomain)) {
    field.setErrors(null)
  } else {
    field.setErrors([
      i18n.t('company_settings.general.company_page.options.company_page.subdomain_error'),
    ])
  }
}
